import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import {
  getServices,
  createService,
  updateService,
  deleteService,
  getServiceById,
} from "../api/services"

export const useFetchServices = (offset, limit, search) => {
  return useQuery({
    queryKey: ["services", offset, limit, search],
    queryFn: async () => {
      const res = await getServices({ offset, limit, search })
      return res.data
    },
    select: (response) => ({
      services: response.data.services,
      pagination: {
        total: response.data.total,
        totalPages: Math.ceil(response.data.total / limit),
      },
    }),
    staleTime: 5 * 60 * 1000,
  })
}

export const useCreateService = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data) => createService(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["services"] })
    },
  })
}

export const useUpdateService = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }) => updateService(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["services"] })
      queryClient.invalidateQueries({ queryKey: ["service"] })
    },
  })
}

export const useDeleteService = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (serviceId) => deleteService(serviceId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["services"] })
    },
  })
}

export const useGetServiceById = (id) => {
  return useQuery({
    queryKey: ["service", id],
    queryFn: async () => {
      const response = await getServiceById(id)
      return response.data.data
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
  })
}
